export const STATUS_COLORS = {
  'Top Performer': {
    bg: 'bg-green-100 dark:bg-green-500/15',
    text: 'text-green-700 dark:text-green-300',
    border: 'border-green-300 dark:border-green-500/40',
    dot: '#16a34a',
    ring: 'ring-green-400',
  },
  'Efficient': {
    bg: 'bg-purple-100 dark:bg-purple-500/15',
    text: 'text-purple-700 dark:text-purple-300',
    border: 'border-purple-300 dark:border-purple-500/40',
    dot: '#9333ea',
    ring: 'ring-purple-400',
  },
  'Underdelivering': {
    bg: 'bg-orange-100 dark:bg-orange-500/15',
    text: 'text-orange-700 dark:text-orange-300',
    border: 'border-orange-300 dark:border-orange-500/40',
    dot: '#ea580c',
    ring: 'ring-orange-400',
  },
  'Unacceptable Output': {
    bg: 'bg-red-100 dark:bg-red-500/15',
    text: 'text-red-700 dark:text-red-300',
    border: 'border-red-300 dark:border-red-500/40',
    dot: '#dc2626',
    ring: 'ring-red-400',
  },
};

export const getStatusColors = (status) =>
  STATUS_COLORS[status] || {
    bg: 'bg-gray-100 dark:bg-slate-500/20',
    text: 'text-gray-700 dark:text-slate-300',
    border: 'border-gray-300 dark:border-slate-500/40',
    dot: '#6b7280',
    ring: 'ring-gray-400',
  };

export const formatRate = (rate) => `${Number(rate ?? 0).toFixed(1)}%`;

export const ALL_STATUSES = [
  'Top Performer',
  'Efficient',
  'Underdelivering',
  'Unacceptable Output',
];
